<template>
	<v-container grid-list-md class="pa-0">
		<v-layout row wrap>
			<v-flex xs12 v-if="!multiple">
				<v-img
					:src="
						value && value.url
							? value.url
							: '/images/image_placeholder.jpg'
					"
					@click="openDialog"
					:aspect-ratio="4 / 3"
					:height="height"
					:width="width"
				></v-img>
			</v-flex>
			<v-flex xs12 md12 v-else>
				<v-layout row wrap>
					<v-flex xs12 md12>
						<v-btn color="success" @click="openDialog">
							{{ $t("label.choose_images") }}
						</v-btn>
					</v-flex>
					<v-flex
						xs12
						md6
						v-for="(img, index) in images"
						:key="index"
						class="py-1 px-1"
					>
						<v-img
							:src="img.thumb_url"
							width="130"
							height="130"
						></v-img>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-dialog v-model="dialog" persistent>
			<v-card>
				<v-toolbar class="primary" dark flat>
					<v-toolbar-title style="width: 200px"
						>{{ $t("title.media_library") }}
					</v-toolbar-title>
					<v-spacer></v-spacer>
					<filter-image
						v-model="filter"
						@onFilter="getItems()"
						:loading="!$wait.is('loading')"
					></filter-image>
				</v-toolbar>
				<v-divider></v-divider>
				<v-card-text style="min-height: 60vh">
					<v-container grid-list-md text-xs-center>
						<v-item-group v-model="item" :multiple="multiple">
							<v-card
								class="d-flex align-content-start flex-wrap"
								flat
								tile
							>
								<v-card flat class="pa-2">
									<template v-if="!loading">
										<input
											type="file"
											id="file"
											@change="uploadFile"
											multiple
											accept="image/*"
										/>
										<label for="file"
											><v-img
												:src="'/images/image_placeholder.jpg'"
												width="100"
												height="100"
											></v-img>
										</label>
									</template>
									<template v-else>
										<half-circle-spinner
											:animation-duration="1000"
											:size="97"
											color="#ff1d5e"
										/>
									</template>
								</v-card>
								<template v-if="!$wait.is('loading')">
									<v-card
										v-for="(m, index) in media"
										:key="index"
										class="pa-2"
										flat
									>
										<v-item
											v-slot="{ active, toggle }"
											:value="m"
										>
											<v-card
												flat
												@click="toggle"
												:style="{
													opacity: active
														? '1'
														: '0.5',
												}"
												height="170"
												width="100"
												min-width="100"
												min-height="170"
											>
												<v-img
													:src="m.thumb_url"
													:lazy-src="m.thumb_url"
													aspect-ratio="1"
													class="grey lighten-2"
												>
													<template
														v-slot:placeholder
													>
														<v-row
															class="
																fill-height
																ma-0
															"
															align="center"
															justify="center"
														>
														</v-row>
													</template>
													<v-btn icon color="green">
														<v-icon>
															{{
																active
																	? "mdi-check"
																	: null
															}}
														</v-icon>
													</v-btn>
												</v-img>
												<v-card-text class="py-0 px-0">
													<p class="module">
														{{ m.filename }}.{{
															m.extension
														}}
													</p>
												</v-card-text>
											</v-card>
										</v-item>
									</v-card>
								</template>
								<template v-else>
									<v-card
										v-for="(x, ind) in 29"
										:key="ind"
										height="120"
										width="115"
										class="pa-2"
										flat
									>
										<v-skeleton-loader
											class="mx-auto text-center"
											max-width="300"
											max-height="120"
											type="card,list-item-two-line"
										></v-skeleton-loader>
									</v-card>
								</template>
							</v-card>
						</v-item-group>
					</v-container>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<div class="text-center">
						<v-pagination
							v-model="currentPage"
							:length="total"
							:total-visible="7"
						></v-pagination>
					</div>
					<v-spacer></v-spacer>
					<v-btn text @click="cancel()">{{
						$t("label.cancel")
					}}</v-btn>
					<v-btn
						@click="insertMedia()"
						color="primary"
						:disabled="!item"
						>{{ $t("label.insert_media") }}</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import pickBy from "lodash/pickBy";
export default {
	props: {
		value: {
			default: null,
		},
		multiple: {
			default: false,
		},
		width: {
			required: false,
			default: "100%",
		},
		height: {
			required: false,
			default: "100%",
		},
	},
	components: {
		HalfCircleSpinner,
	},
	data() {
		return {
			dialog: false,
			tab: null,
			currentPage: 1,
			item: null,
			file: [],
			knowledge: 33,
			media: [],
			total: 0,
			loading: false,
			filter: {},
		};
	},

	watch: {
		currentPage(newVal, oldVal) {
			this.getItems(newVal);
		},
	},
	methods: {
		async getItems(item) {
			try {
				var pageNumber = item ? item : 1;
				var filter = pickBy(this.filter);
				this.$wait.start("loading");
				const { data, status } = await axios.get(
					this.$route("central.media_library.index", {
						page: pageNumber,
						filter,
					})
				);

				if (status == 200) {
					this.media = data.data.data;
					this.total = data.data.meta.last_page;
				}
			} finally {
				this.$wait.end("loading");
			}
		},
		openDialog() {
			this.item = this.value;
			this.dialog = true;
			this.getItems();
		},

		insertMedia() {
			this.$emit("input", this.item);
			this.dialog = false;
		},
		cancel() {
			this.dialog = false;
		},

		async uploadSuccess(file, response) {
			this.media.unshift(response.data);
			this.item = response.data;
			this.removeAllFiles();
			this.tab = 0;
		},

		async uploadFile(e) {
			try {
				this.loading = true;
				const formData = new FormData();
				var files = e.target.files;
				for (var i = 0; i < files.length; i++) {
					formData.append("file[]", files[i]);
				}

				const { success, status } = await axios.post(
					this.$route("central.media_library.store"),
					formData,
					{
						headers: {
							"Content-type": "multipart/form-data",
						},
					}
				);
				if (status == 200) {
					await this.getItems();
				}
			} finally {
				this.loading = false;
			}
		},
	},

	computed: {
		images() {
			if (this.item) {
				return this.item;
			}
			return this.value;
		},
	},

	// async created() {
	// 	await this.getItems();
	// 	// if (this.media.length <= 0) {

	// 	// }
	// },
};
</script>

<style scoped>
.v-image {
	cursor: pointer;
}
.module {
	display: -webkit-box;
	max-width: 200px;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
input[type="file"] {
	display: none;
}
</style>
